export default {
  path: '/eventCallback',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'eventCallback',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
